export default __webpack_public_path__ + "static/media/finished@2x.e2f8e06b.png";